import { Table } from "@mantine/core"
import type { ReactNode } from "react"

export function TableHeaders({ children = [] }: { children?: ReactNode[] }) {
  if (!children.length) return null

  return (
    <Table.Thead>
      <Table.Tr>
        {children.map((header, index) => (
          // biome-ignore lint: reason
          <Table.Th key={index}>{header}</Table.Th>
        ))}
      </Table.Tr>
    </Table.Thead>
  )
}
